import React from 'react'
import { Pagination } from 'react-bootstrap'

const PaginationButtons = (props) => {

  const { numberOfPages, currentPage, buttonsPerPage, disabled } = props


  let lastPaginationPage = currentPage + buttonsPerPage - 1

  if (currentPage <= buttonsPerPage) {
    lastPaginationPage = buttonsPerPage
  } else if (currentPage > buttonsPerPage && currentPage % buttonsPerPage === 0) {
    lastPaginationPage = currentPage
  } else if (currentPage > buttonsPerPage && currentPage % buttonsPerPage > 0) {
    let remainder = currentPage % buttonsPerPage
    lastPaginationPage = currentPage - remainder + 5
  }


  // THE FOR LOOP ADDS PAGINATION BUTTONS FOR EACH NUMBER OF PAGES
  let buttons = []

  for (let i = 0; i < numberOfPages; i++) {
    const buttonPage = i + 1
    // const nextPage = i + 1

    buttons.push(
      <Pagination.Item
        active={currentPage === i + 1}
        key={i}
        onClick={() => props.onClick(buttonPage)}
        disabled={ !!disabled }
      >
        {buttonPage}
      </Pagination.Item>
    )
  }

  // props ARRAY ADDS BUTTONS THAT TAKE THE USER TO THE FIRST PAGE AND BACK ONE PAGE
  // IN THE PAGINATED PROJECT RESULTS
  let previousButtons = [
    <Pagination.First
      key={'pagination-first'}
      disabled={ currentPage === 1 || !!disabled }
      onClick={currentPage === 1 ? null : () => props.onClick(1)}
    />,
    <Pagination.Prev
      key={'pagination-back'}
      disabled={currentPage === 1 || !!disabled }
      onClick={() => currentPage === 1 ? null: props.onClick(currentPage - 1)}
    />
  ]

  // props ARRAY ADDS BUTTONS THAT TAKE THE USER TO THE LAST PAGE AND FORWARD ONE PAGE
  // IN THE PAGINATED PROJECT RESULTS
  let nextButtons = [
    <Pagination.Next
      key={'pagination-next'}
      disabled={ currentPage === numberOfPages || !!disabled }
      onClick={() => currentPage === numberOfPages ? null: props.onClick(currentPage + 1)}
    />,
    <Pagination.Last
      key={'pagination-last'}
      disabled={ currentPage === numberOfPages || !!disabled }
      onClick={currentPage === numberOfPages ? null : () => props.onClick(numberOfPages)}
    />
  ]

  return (
    <Pagination>
      {[...previousButtons, ...buttons.slice(lastPaginationPage - buttonsPerPage, lastPaginationPage), ...nextButtons]}
    </Pagination>
  )
}

export default PaginationButtons



// WEBPACK FOOTER //
// ./src/reuseable-components/PaginationButtons.js